import { connect } from 'react-redux'
import Page from './page'
import { config } from '../../../redux/selectors'
import { withRouter } from 'react-router-dom'

const mapState = (state, ownProps) => {
  return {
    config: config(state),
    ...ownProps,
  }
}

const mapDispatch = dispatch => {
  return {}
}

export default withRouter(connect(mapState, mapDispatch)(Page))



// WEBPACK FOOTER //
// ./src/components/common/page/page.connect.js